var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.show)?_c('div',{staticClass:"modal"},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.data.show = false}}},[_vm._v("×")]),_c('img',{staticClass:"modal-content",attrs:{"src":_vm.data.img}}),_c('div',{attrs:{"id":"caption"}},[_vm._v(_vm._s(_vm.data.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }